import React, { useEffect } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import generalStyles from '../websiteMain.module.css';
import styles from './general.module.css';

function CookiePolicy(props) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div >
            <Header />
            <div className={generalStyles.mainLayout}>
                <div className={`${generalStyles.container}`}>
                    <h1 className={`${generalStyles.H1} ${styles.headerTitle}`}>
                        Cookie Policy
                    </h1>
                    <br />
                    <div className={`pt-2`}>
                        <h2 className={generalStyles.generalH3}>1. General information</h2>
                        <p className={generalStyles.generalP}>Yaz Häuser AG, which owns and operates <a className={generalStyles.generalA}
                            href={"/"}>www.beehaz.com </a> (“Beehaz”)
                            hereby provide an explanation about how we use cookies when you visit our website.
                        </p>
                        <p className={generalStyles.generalP}>
                            <strong>1.2</strong>
                            &nbsp;&nbsp;Cookies are text files which store pieces of information. They are stored
                            in your browser when a website is loaded. They help a website function properly and enable a better user experience.
                            They also help service providers like Beehaz to analyse how to improve our services.
                        </p>
                    </div>
                    <div className={`pt-2`}>
                        <h2 className={generalStyles.generalH3}>2. Types of cookies and how they are used</h2>
                        <p className={generalStyles.generalP}>
                            <strong>2.1</strong>
                            &nbsp;&nbsp; Beehaz may use cookies of
                            our own that only collect anonymous data necessary for the proper functioning of our website.
                        </p>
                        <p className={generalStyles.generalP}>
                            <strong>2.2</strong>
                            &nbsp;&nbsp;Third-party cookies can also be used to help us understand how the website performs
                            and your interaction with our system. This way, we may make the necessary improvements to our
                            interface to improve the user experience by making our website more intuitive.
                        </p>
                        <p className={generalStyles.generalP}>
                            <strong>2.3</strong>
                            &nbsp;&nbsp;Cookies can be necessary or used for analytics. Necessary cookies are used to maintain
                            user sessions and maintain security. They do not collect personal information.
                            Analytical cookies help us know how many visitors our website receives daily,
                            which URL referred them to us, the browser the user is using, and the type of device.
                        </p>
                    </div>
                    <div className={`pt-2`}>
                        <h2 className={generalStyles.generalH3}>3. Cookie consent and deletion</h2>
                        <p className={generalStyles.generalP}>
                            <strong>3.1</strong>
                            &nbsp;&nbsp;If you already have consented, you can withdraw your consent at any time for
                            the cookie installation. Please note this will not affect the necessary cookies the website
                            needs to maintain basic functionality.
                        </p>
                        <p className={generalStyles.generalP}>
                            <strong>3.2</strong>
                            &nbsp;&nbsp;You can delete cookies from your browser any time.
                            You can do this usually in the browser settings.
                            Please check the instructions from your browser provider for more information.
                        </p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}


export default CookiePolicy;